import { render, staticRenderFns } from "./BmTopicWorlds.vue?vue&type=template&id=c8c278aa&scoped=true&"
import script from "./BmTopicWorlds.vue?vue&type=script&lang=js&"
export * from "./BmTopicWorlds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c278aa",
  null
  
)

export default component.exports